@if (data(); as _data) {
	<ada-table
		#CpeWebViewTable
		data-testid="CpeWebViewTable"
		[allowAdvancedSearch]="true"
		[data]="_data"
		[expandableContentTemplate]="ExpandableContentTemplate"
		[handlePagination]="true"
		[id]="id"
		[includeActionsColumn]="false"
		[includeFiltering]="true"
		[includeHeaderMenu]="false"
		(columnHeaderSelected)="onSort($event)"
		(filterConditionChange)="onFilter($event)"
	>
		<ng-template
			#ExpandableContentTemplate
			let-row
		>
			<ada-container
				horizontalSpacing="Small"
				padding="0px {{ ui.Spacing.SPACING_XLARGE }}"
				verticalSpacing="Small"
				[colCount]="4"
			>
				<!-- Cpe Web View -->
				<ada-text
					content="Version Start Including"
					fontWeight="Bold"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				/>
				<ada-text
					content="{{ row.versionStartIncluding }}"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				/>

				<ada-text
					content="Version End Including"
					fontWeight="Bold"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				/>
				<ada-text
					content="{{ row.versionEndIncluding }}"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				/>

				<ada-text
					content="Version Start Including"
					fontWeight="Bold"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				/>
				<ada-text
					content="{{ row.versionStartExcluding }}"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				/>

				<ada-text
					content="Version End Excluding"
					fontWeight="Bold"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				/>
				<ada-text
					content="{{ row.versionEndExcluding }}"
					[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				/>

				<ada-horizontal-separator [colSpan]="4" />

				<!-- Cpe Info -->
				<ada-cpe-info-view
					[colSpan]="4"
					[cpeInfo]="row.cpeInfo"
				/>
			</ada-container>
		</ng-template>
	</ada-table>
}
